import { Component, OnInit } from '@angular/core';
import { EngagmentCountModel } from '../../../models/engagment-count.model';
import { CommonSharedModule } from '../../common/shared.module';
import { OsmosisService } from '../../services/osmosis.service';

@Component({
  selector: 'app-incentive-count',
  templateUrl: './incentive-count.component.html',
  styleUrls: ['./incentive-count.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class IncentiveCountComponent implements OnInit {
  activityCount!: EngagmentCountModel;
  loading = false;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.loading = true;
    this.osm.getIncentiveCountRequiringAction().subscribe(activityCount => {
      this.activityCount = activityCount;
      this.loading = false;
    });
  }
}
